import { useState } from "react";
import { REFETCH_INTERVAL_TIME } from "src/constant/common";
import { usePatchedNavigate } from "src/Hooks/usePatchedNavigate";
import { useQuery } from "src/Hooks/useReactQuery";
import APP_ROUTES from "src/routes/routes";
import { getProjectInstances } from "src/services/project-instances";
import { handleScrollTo } from "src/utils/common";

const useGetProjectInstanceList = (params, onSettledCallback) => {
  const [allowScrollToId, setAllowScrollToId] = useState(true);
  const {
    page = 1,
    limit = 9999999,
    q,
    isSelectOptions = false,
    id,
    refetchInterval = REFETCH_INTERVAL_TIME,
    refetchOnWindowFocus = true,
  } = params || {};
  const navigate = usePatchedNavigate();

  const { data, isLoading, isError, error, refetch, isFetching } = useQuery({
    queryKey: ["getProjectInstances", page, q],
    queryFn: () => {
      const params = { page, limit, simple_list: isSelectOptions };
      if (q) {
        params.q = q;
      }
      return getProjectInstances(params);
    },
    enabled: true,
    cacheTime: 0,
    onSuccess: async () => {
      if (id && allowScrollToId) {
        handleScrollTo(0, 90, `row${id}`);
        setAllowScrollToId(false);
      }
    },
    select: (data) => {
      if (isSelectOptions) {
        return (
          data?.items?.map((item) => ({
            label: `${item.increment_id} - ${item.name}`,
            value: item.id,
          })) || []
        );
      }
      return data;
    },
    onError: (error) => {
      if (error?.response?.status === 404) {
        navigate(APP_ROUTES.NOT_FOUND);
      }
    },
    onSettled: () => {
      if (onSettledCallback) {
        onSettledCallback();
      }
    },
    refetchInterval,
    refetchOnWindowFocus,
  });

  return {
    projectInstanceList: data,
    projectInstanceListRefetch: refetch,
    isLoadingProjectInstanceList: isLoading,
    isErrorProjectInstanceList: isError,
    errorProjectInstanceList: error,
    isFetchingProjectInstanceList: isFetching,
    refetchProjectInstanceListInterval: refetchInterval,
  };
};

export default useGetProjectInstanceList;
